/* unplugin-vue-components disabled */import script from "./SectionTitleWithTabs.vue?vue&type=script&lang=ts&setup=true"
export * from "./SectionTitleWithTabs.vue?vue&type=script&lang=ts&setup=true"

import "./SectionTitleWithTabs.vue?vue&type=style&index=0&id=61bed7ca&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-61bed7ca"]])

export default __exports__